import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

import Container from '../../../Core/Container';
import Image from '../../../Core/Image';
import Ctas from '../../../Core/Ctas';

export const Grid = styled(Container)`
  display: flex;
  flex-direction: column;

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: row;
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
  }

  &.normal-font {
    h2 {
      font-weight: normal;
    }
  }

  &.special-offers.standalone {
    margin: unset;
    width: 100%;
  }
`;

export const Header = styled.h2`
  margin-top: 1rem;
  margin-bottom: 1rem;
  line-height: 130%;

  &.normal-font {
    font-size: 1.5rem;
  }

  strong {
    font-size: inherit !important;
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-top: 1rem;
    margin-bottom: 0.5rem;
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    margin-top: 1.5rem;
    margin-bottom: 0.5rem;
  }
`;

export const Img = styled(Image)`
  width: 100%;
  height: 100%;
  max-width: 23rem;
  max-height: 500px;

  ${Grid}.credit-card & {
    max-width: 8.75rem;
    max-height: auto;
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    ${Grid}.credit-card & {
      max-width: 12.5rem;
    }
  }
`;

export const StyledCtas = styled(Ctas)`
  margin: 1rem 0;
  a {
    margin: 0;
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin: 1rem 0 0;
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    margin: 1.5rem 0 0;
  }
`;

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 2rem 1.5rem;
  outline: 1px solid ${themeGet(`colors.stone`)};
  border-radius: 0.625rem;
  gap: 1rem;
  background: ${({ $backgroundColor }) =>
    $backgroundColor ? themeGet(`colors.${$backgroundColor}`) : 'transparent'};
  background-image: url(${({ $backgroundImage }) =>
    $backgroundImage ? $backgroundImage.asset.localImage.publicURL : ''});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: row;
    padding: 1.5rem;
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 2.75rem 2.25rem;
  }

  border-top: ${({ theme, $borderTopColor }) =>
    $borderTopColor ? `5px solid ${theme.colors[$borderTopColor]}` : 'none'};

  &.borderless {
    outline: none;
    padding: 0;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  align-self: center;
  width: 100%;

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: ${props => (props.$hasImg ? '60%' : '100%')};
    text-align: left;
    align-items: start;

    ${Wrapper}.image-left & {
      order: 2;
    }
  }

  ${Grid}.standalone & {
    text-align: left;
    align-items: start;
  }
`;

export const Body = styled.div`
  font-size: 1rem;
`;

export const ImageWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  ${Wrapper}.image-left & {
    order: 1;
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 40%;
    justify-content: flex-end;

    ${Wrapper}.image-left & {
      justify-content: flex-start;
    }

    ${Grid}.credit-card & {
      justify-content: center;
    }
  }
`;
